var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"input-value":_vm.value,"label":_vm.label,"disabled":_vm.isDisabled},on:{"change":_vm.handleCheck}})}
var staticRenderFns = []

export { render, staticRenderFns }